module.exports = __webpack_public_path__ + "images/favicon_dollar.ico";